import React from "react";
import {Menu, MenuItem, Tooltip} from "@mui/material";
import {useTranslation} from "react-i18next";
import LanguageIcon from '@mui/icons-material/Language';
import {AnimatedIconButtonWithLabel} from "../general/button/IconButtonWithLabel";


export default function LanguageButton(props) {
    const {t, i18n} = useTranslation('common');
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const setValue = key => () => {
        i18n.changeLanguage(key);
        setAnchorEl(null);
    };

    return (
        <>
            <Tooltip title={t('main.components.button.language')} arrow>
                <AnimatedIconButtonWithLabel
                    {...props}
                    aria-controls="language-menu"
                    aria-haspopup="true"
                    aria-label="display more actions"
                    onClick={handleClick}
                    label={i18n.language.startsWith("en") ? "EN" : "FR"}
                >
                    <LanguageIcon/>
                </AnimatedIconButtonWithLabel>
            </Tooltip>
            <Menu
                id="language-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                <MenuItem onClick={setValue('en')}>EN</MenuItem>
                <MenuItem onClick={setValue('fr')}>FR</MenuItem>
            </Menu>
        </>
    );
}